import React,{ Component } from 'react';
import { Link, browserHistory } from 'react-router';
import $ from 'jquery';
import { ShareButtons, generateShareIcon } from 'react-share';
import { Panel } from 'react-bootstrap';
import Footer from './footer.js';
const {FacebookShareButton,GooglePlusShareButton,TwitterShareButton} = ShareButtons;
const FacebookIcon = generateShareIcon('facebook');
const TwitterIcon = generateShareIcon('twitter');
const GooglePlusIcon = generateShareIcon('google');

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets = 'https://aquadeals.in/admin/assets/';

export default class Share_Earn extends Component{
	constructor(props){
		super(props);
		this.state={
			balance:0,
			code:'',
			refferal_cash:0,
			frnd_cash:0,
			tot_amt:0,
			image:'',
			status:'',

			open: true,
			open2:true,
			shareUrl: '',
			msg: '',
			url:'',
		};
		this.getShareDetails=this.getShareDetails.bind(this);
		this.shareEarn=this.shareEarn.bind(this);
	}
	componentDidMount()
	{
		// localStorage.setItem('share_earn','/share_earn');
		if(screen.width >=800)
		{
			window.location.href="/web/share_earn";
		}
		if(!localStorage.user_id && !localStorage.token)
		{
			localStorage.setItem('share_earn','/share_earn');
			browserHistory.push('/login');
		}
		else
		{
			this.getShareDetails();
			this.shareEarn();	
		}
	}
	shareEarn()
	{	
		// this.setState({
		// 	open: !this.state.open,
		// });
		var data1={from:'mobile_web',id:localStorage.getItem('user_id'),token:localStorage.getItem('token')};
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'post',
			url:baseUrl+'shareAppurl',
			dataType: 'json',
			data:{req:data2},
			success:function(data)
			{
				this.setState({
					msg:data.share_data,
					url:data.tinyurl,
				});
			}.bind(this),
			error:function(err)
			{
				
			}
		});
	}
	getShareDetails()
	{
		var data1={from:'mobile_web',id:localStorage.getItem('user_id'),token:localStorage.getItem('token')};
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'post',
			url:baseUrl+'referAndEarn',
			dataType: 'json',
			data:{req:data2},
			success: function(data)
			{
				this.setState({
					balance:data.balance,
					code:data.code,
					refferal_cash:data.refferal_cash,
					frnd_cash:data.frnd_cash,
					tot_amt:data.tot_amt,
					image:data.image,
					status:data.status,
				});
			}.bind(this),
			error:function(err)
			{
			}
		});
	}
	chatnow(){
     	   this.shareEarn();
		   location.href="https://wa.me?text="+this.state.msg;
 	}	
	render()
	{
	document.title="Share & Earn | AquaDeals";
	var msg=this.state.msg;
	var url=this.state.url;
	// var sh_url=this.state.msg;
	var description=this.state.msg;
	if(this.state.msg !=='')
	{
		var title=this.state.msg;
	}
	else
	{
		// title="Hey! Use my code "+code+ "to signup and get Rs2000 AquaCash. Click https:\/\/goo.gl\/gvP4pb to download the AquaDeals Android app";
		title=msg;
	}
	return(
			<div className="mob_deals mob_share_earnpage">
				<div className="page_hdr">
					<div className="container-fluid">
						<h5><Link to={"/"}><i><img src={baseAssets+'icons/web_icons/close_icon1.png'} className="cross_icon" width="14px" alt=" "/></i> <span className="header_text">Share & Earn</span></Link></h5>
						<a href="/" className="home_logo1">
							<img src={baseAssets+'mob-assets/home1.png'} alt="Home" />
						</a>
					</div>
				</div>
				
				<section className="container-fluid">
					<div className="row lst_img">
						<img src={baseAssets+'images/promo_offers/20170116202638300621.png'} alt="" />
					</div>
					<div className="row">
						<h4 className="share_invite_header">Total referral earnings: &#8377;{this.state.tot_amt}</h4>
						<div className="col-md-12 col-sm-12 col-xs-12 share_earn_blk">
							<div className="">
								<h5>Your referral code</h5>
								<button className="sh_ern_code">{this.state.code}</button>
								<button onClick={()=>{this.chatnow()}}><i><img src={baseAssets+'icons/web_icons/refer_share.png'} alt="share" width="30px" /></i></button>
							</div>
						</div>
						
						{/*<div style={{clear:'both'}}>
							<Panel className="share_earn_panel" collapsible expanded={this.state.open}>
								<FacebookShareButton url={url} title={title} className="test_earn_share">
						            <FacebookIcon size={50} round />
						        </FacebookShareButton>
						        <TwitterShareButton url={url} title={title} description={description} className="test_earn_share">
						            <TwitterIcon size={50} round />
						        </TwitterShareButton>
								<GooglePlusShareButton url={url} title={title} descirption={description} className="test_earn_share">
						            <GooglePlusIcon size={50} round />
						        </GooglePlusShareButton>
					       </Panel>
						</div>*/}
						<div style={{clear:'both'}}>
							<p className="share_invite_msg">Invite your friends</p>
							<Panel className="share_earn_panel" collapsible expanded={this.state.open2}>
								<FacebookShareButton url={url} title={title} className="test_earn_share">
						            <FacebookIcon size={50} round />
						        </FacebookShareButton>
						        <TwitterShareButton url={url} title={title} description={description} className="test_earn_share">
						            <TwitterIcon size={50} round />
						        </TwitterShareButton>
						        <section className="test_earn_share" id="wb_circle" onClick={()=>{this.chatnow()}}>
							         <i><img  src={require('./../../../assets/images/wa_app.png')} width="30" alt="" /></i>						        
						        </section>	
					       </Panel>
						</div>
						<div className="clr">&nbsp;</div>
					</div>
				</section>
				{/*<Footer />*/}
			</div>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/components/Categories/Common/Share_Earn.js
 **/